import { Component } from '@angular/core';
import { ToastBaseComponent } from '@shared/modules/toast/components/toast-base/toast-base.component';

@Component({
  selector: 'app-simple-toast-message',
  templateUrl: './simple-toast-message.component.html',
  styleUrls: ['./simple-toast-message.component.scss'],
})
export class SimpleToastMessageComponent extends ToastBaseComponent {}
